export const FOOTER_TEST_IDS = {
  appCol: 'footer-app-col',
  seoLink: 'footer-seo-link',
  customerHelp: 'footer-consumer-support'
};
